export default {
    title: "Início",
    addOrder: {
        title: "Registrar pedido",
        date_time: "Data e Hora",
        order_value: "Valor do pedido",
        client_phone: "Telefone do cliente",
        success_message: "Pedido registrado com sucesso",
        new_client_message: "Novo cliente na base, solicite o cadastro!",
        not_registered_message: "O Cliente ainda não se cadastrou",
        anonymous_title: "Pedido anônimo",
        anonymous_body:
            "Você está gerando um pedido sem informar o cliente. <br /><br />Isso reduz a eficácia e precisão dos relatórios, sempre lembre de pedir o telefone ao cliente.",
        suspect_value_title: "Alerta de valor suspeito! ({0})",
        suspect_value_body:
            'Você está gerando um pedido com um valor de <span style="display: inline-block">{0}</span> o que é muito acima do normal. <br /><br />Clique em confirmar se isso não for um erro.',
        register_button: "Registrar Pedido",
        save_button: "Salvar",
        value_error: "Favor checar o valor do pedido",
        generic_success: "Pedido salvo com sucesso",
        personalized_success: "Obrigado {0}, você já tem {1} pontos!",
        welcome_points: "Seja bem vindo, você já possui {0} pontos!",
        thanks_points: "Obrigado, você já possui {0} pontos!",
    },
    searchClient: {
        title: "Buscar cliente",
        confirm_reward_title: "Confirmar resgate do prêmio",
        confirm_reward_body:
            'Resgatar o prêmio "{0}"? por {1} pontos? <br /> Essa ação é irreversível.',
        reward_success_title: "Prêmio resgatado com sucesso!",
        reward_success_body:
            'O prêmio "{0}" foi resgatado com sucesso por {1} pontos. <br />',
        client_points_title: "{0} tem <strong>{1}</strong> pontos",
        client_coupons_title: "Cupons {0}",
        processing_coupons_title: "Cupons em processamento",
        processing_coupons_desc:
            "Esses cupons ainda estão sendo processados e logo o código será gerado.",
        automation_origin: "Automação de origem: {0}",
        active_coupons_title: "Cupons ativos",
        validity: "Validade:",
        until: "até:",
        not_registered: "Cliente não cadastrado",
        send_sms_link: "Enviar SMS de Cadastro",
        coupons_label: "Cupons:",
        processing_label: "({0} em processamento)",
        view_coupons: "Ver cupons",
        points_label: "Pontos:",
        view_rewards: "Ver recompensas",
        orders_label: "Pedidos:",
        birthdate_label: "Aniversário:",
        email_label: "E-mail:",
        phone_label: "Telefone:",
        view_profile: "Ver perfil",
        coupon_not_yet_valid: "O cupom ainda não é válido",
        coupon_expired: "O cupom já expirou",
        sms_success: "Link enviado com Sucesso!",
        sms_error:
            "Ops! Ocorreu um error ao enviar o Link. Por favor, Tente novamente mais tarde.",
    },
    validateCoupon: {
        title: "Validar cupom",
        confirm_use_title: "Confirmar uso do cupom",
        confirm_use_body:
            "Conceder o benefício de {0}? <br /> Essa ação é irreversível.",
        used_success_title: "Cupom utilizado",
        used_success_body:
            "Cupom de {0} foi utilizado com sucesso. <br /> O cupom {1} não é mais válido",
        error_expired: "Cupom expirou",
        error_not_yet_valid: "Cupom será válido a partir de",
        error_used: "Cupom já utilizado",
        error_not_found: "Cupom inválido",
        valid_coupon: "Cupom válido",
        validate_button: "Validar cupom",
        use_button: "Usar cupom",
    },
};
